<template>
  <v-container
    id="faq-i"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          icon="mdi-frequently-asked-questions"
        >
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              FAQ-I
            </div>
          </template>
          <template #after-heading-right>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="searchText"
                class="purple-input"
                label="Search"
              />
            </v-col>
          </template>
          <faq
            :faqs="faqs"
            :tab="3"
            :search-text="searchText"
            @request-load-faqs="loadFaqs"
          />
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Faq from './components/faq.vue'
  import { fetchFaq } from '@/firebase'
  export default {
    components: { Faq },
    data: () => ({
      faqs: [],
      searchText: '',
    }),
    mounted () {
      this.loadFaqs()
    },
    methods: {
      loadFaqs () {
        fetchFaq().then(results => {
          this.faqs = results
        })
          .catch(error => {
            console.log(error)
          })
      },
    },
  }
</script>
